import { keyframes } from '@emotion/react';
const slideInAnimation = keyframes `
  from {
    transform: translateY(100%)
  }
  to {
    transform: translateY(0%)
  }
`;
const slideOutAnimation = keyframes `
  from {
    transform: translateY(0%)
  }
  to {
    transform: translateY(100%)
  }
`;
const useCookieBannerStyles = (backgroundColor, font, transition) => {
    // base button style
    const buttonStyle = {
        fontSize: font.base.size.s,
        cursor: 'pointer'
    };
    return {
        container: {
            backgroundColor: backgroundColor.active,
            paddingLeft: '1rem',
            paddingRight: '1rem',
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            minHeight: 150,
            zIndex: 801
        },
        slideIn: {
            animation: `${slideInAnimation} ${transition.duration.default} linear`
        },
        slideOut: {
            animation: `${slideOutAnimation} ${transition.duration.default} linear`
        },
        hidden: {
            display: 'none'
        },
        desktopText: {
            fontSize: font.base.size.m
        },
        mobileText: {
            fontSize: font.base.size.s
        },
        button: buttonStyle,
        cookieBannerButton: Object.assign(Object.assign({}, buttonStyle), { marginRight: '8px', marginBottom: '8px' }),
        landscapeMobileCookieBannerButton: Object.assign(Object.assign({}, buttonStyle), { marginRight: '8px', marginBottom: '8px', width: '48%' }),
        mobileCookieBannerButton: Object.assign(Object.assign({}, buttonStyle), { marginRight: '8px', marginBottom: '8px', width: '98%' }),
        verticalScroll: {
            overflowY: 'auto',
            maxHeight: '30vh'
        }
    };
};
export default useCookieBannerStyles;
//# sourceMappingURL=cookieBannerStyles.js.map